import { IProjectParticipantsResponseData } from "models/healthAuthorities.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const projectParticipantsQueryConfig = {
  getProjectParticipants: {
    query: queries.project.getProjectParticipants,
    queryKey: [QueryAPIKey.GetProjectParticipants],
    errorMessageKey: "getProjectParticipantsFailure",
    queryOptions: {
      select: (data: {
        projectParticipants: IProjectParticipantsResponseData[];
      }): IProjectParticipantsResponseData[] => data.projectParticipants,
    },
  },
};
